import React from 'react';
import { Stack, HStack, VStack, Box, Text } from '@chakra-ui/react';
import Navbar from '../components/navbar';
import { Link } from 'react-router-dom';
const Gools = () => {
  return (
    <>
      <Box bg={'#91B8B4'} h={'130vh'}>
        <Navbar />
        <VStack spacing={4} align="stretch" alignItems={'center'}>
          <Box>
            <HStack spacing="24px" mt={'50px'} mb={'10px'}>
              <Text fontSize="60px" color={'#0F2837'}>
                اهداف ترجم
              </Text>
            </HStack>
          </Box>
          <Box mt={'30px !important'}>
            <Box
              border={'1px solid '}
              h={'120px'}
              mb={'30px'}
              textAlign={'center'}
              w="690px"
              bg={'#0F2837'}
  
              borderRadius={'10px '}
            >
              <Text mt={'10px'} p={'5px'} fontSize="30px" color={'#fff'}>
                إثراء المحتوى المعرفي العربي المترجم في مختلف المجالات والعلوم
                والتخصصات
              </Text>
            </Box>
            <Box
              border={'1px solid '}
              h={'120px'}
              mb={'30px'}
              textAlign={'center'}
              w="690px"
              bg={'#0F2837'}
          
              borderRadius={'10px '}
            >
              <Text mt={'10px'} p={'5px'} fontSize="30px" color={'#fff'}>
                ترسيخ مكانة المملكة الدولية كمرجع للترجمة المعتمدة من اللغة
                العربية وإليها
              </Text>
            </Box>
            <Box
              border={'1px solid '}
              h={'120px'}
              mb={'30px'}
              textAlign={'center'}
              w="690px"
              bg={'#0F2837'}
       
              borderRadius={'10px '}
            >
              <Text mt={'10px'} p={'5px'} fontSize="30px" color={'#fff'}>
                ايصال المحتوى المعرفي العربي المترجم من اللغة العربية إلى لغات
                العالم
              </Text>
            </Box>
          </Box>
        </VStack>
        <Box>
          <HStack
            spacing="50px"
            justifyContent={'left'}
            mt={'190px'}
            mb={'50px'}
            ml={'50px'}
          >
            <Link to="/">
              <Box
                textAlign={'center'}
                w="190px"
                h="50px"
                color={'#fff'}
                bg={'#0F2837'}
                fontSize={'30px'}
                borderRadius={'10px'}
              >
                الرجوع للخلف
              </Box>
            </Link>
          </HStack>
        </Box>
      </Box>
    </>
  );
};

export default Gools;
